import ContextProvider, { createContext } from '../../contexts/contextProvider';
import listerReducer, { ListerState, ListerActionTypes } from './listerReducer';

export const ListerContext = createContext<ListerState, ListerActionTypes>(listerReducer, 'ListerContext');
export default ContextProvider;
